<template lang="pug">
.box
  h2.questions_title {{ localizedName }}

  .item(
    v-for="(item, index) in noOfAnswer"
    :key="item"
    :class="{ 'stars_selected': selected === index }"
    @click="submit(item)"
  )

    span {{ tParams('n_stars', '{n} stars', { n: (noOfAnswer + 1) - item }) }}

    .icon
      icon.stars(
        v-for="ls in starNum"
        :key="ls"
        :size="'14'"
        :color="ls <= (noOfAnswer + 1) - item ? 'var(--menu-primary-background-colour)' : '#e0e1e2'"
      ) star
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'
import { getLocalizedCampaignField, t, tParams } from '@/utils/language'

@Component({
  props: {
    index: Number,
    data: Object
  },

  computed: {
    localizedName() {
      const _lang = this.$lang // eslint-disable-line no-unused-vars
      return getLocalizedCampaignField(this.data, 'displayName') || getLocalizedCampaignField(this.data, 'name') || this.data?.name || ''
    },
    starNum () { // 计算星星显示数量，小于 5 按照 5 个显示
      const starNum = this.noOfAnswer
      return starNum < 5 ? 5 : starNum
    }
  }
})

class starComponents extends Vue {
  t(key, fallback) {
    const _lang = this.$lang // eslint-disable-line no-unused-vars
    return t(key, fallback)
  }

  tParams(key, fallback, params) { return tParams(key, fallback, params) }

  selected = null
  noOfAnswer = this.data?.settings?.survey?.noOfAnswer ?? 0

  submit(item) {
    this.selected = item - 1
    const index = this.noOfAnswer - item
    this.$emit('event', index + 1) // 暴露点击事件
  }

  _initializationData() {
    this.selected = null
  }
}

export default starComponents
</script>

<style lang="sass" scoped>
@use "../style/index" as *

.box
  padding: 0 16px

  .item
    color: black
    font-weight: 400

    &:last-child
      margin: 0

  .icon
    display: flex
    align-items: center
    font-size: 14px
    line-height: 14px

    .stars
      margin-right: 4px

      &:last-child
        margin: 0

.box > .item
  margin-bottom: 9px
</style>
